import React, { useState } from 'react';
import SettingsLayout from '../components/SettingsLayout';
import AccountInformation from '../components/AccountInformation';
import SecuritySettings from '../components/SecuritySettings';
import IdentityVerification from '../components/IdentityVerification';

const Index = () => {
  const [activeSection, setActiveSection] = useState('account');

  const renderContent = () => {
   switch (activeSection) {
      case "account":
        return <AccountInformation />;
      case "security":
        return <SecuritySettings />;
      case "identity":
        return <IdentityVerification />;
      default:
        return <AccountInformation />;
    }
  };

  return (
    <SettingsLayout 
      activeSection={activeSection} 
      onSectionChange={setActiveSection}
    >
      {renderContent()}
    </SettingsLayout>
  );
};

export default Index;
